<script>
export default {
  name: 'InputFieldContact',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Enter value...'
    },
    required: {
      type: Boolean,
      default: true
    },
    validation: {
      type: Object,
      required: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required:true
    },
    type: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div class="flex justify-between items-center">
    <div class="w-12">
      <i :class="`${icon} text-gray-500/40 text-2xl`"></i>
    </div>
    <input
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        class="border border-gray-300 rounded-xl px-6 py-4 w-full"
        @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<style scoped>

</style>